export interface PathType {
  location: string;
  path: string[];
}

const getPath = (location: string, path?: string[]): PathType => {
  const home: PathType = {
    location,
    path: path ?? []
  };
  return home;
};

const urlPath: { [key: string]: PathType } = {
  home: getPath('/', ['sidebar.home']),

  //#region crm
  crm: getPath('/crm', ['sidebar.home', 'v2.crm.index']),

  //#endregion crm
  logout: getPath('/logout', []),
  signinOidc: getPath('/signin-oidc', []),
  signoutOidc: getPath('/signout-oidc', []),
  signoutCallbackOidc: getPath('/signout-callback-oidc', []),
  //#endregion

  //#region Server Error
  serverError: getPath('/server-error', [])
  //#endregion
};

export default urlPath;

// CÁI NÀY MỚI THÊM --> KO XÓA
export const newUrlPath = {
  applicationMenuDrawer: '/application-menu'
};
